import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from '../../contexts/LanguageContext';
import './FaqSection.css';

const FaqSection = () => {
  const localizedPath = useLocalizedPath();

  return (
  <section className="home-faq" id="faqs" aria-labelledby="home-faq-title">
    <div className="home-faq__inner">
      <div className="home-faq__intro">
        <span>Questions, answered</span>
        <h2 id="home-faq-title">Everything you need to start with confidence</h2>
        <p>Learn how orders, supplier confirmations, payments, and pickup work before you buy.</p>
        <Link to={localizedPath('/about')}>Learn more about Eulua</Link>
      </div>
      <div className="home-faq__list">
        <details>
          <summary>What is Eulua?</summary>
          <p>Eulua is a B2B marketplace that connects business buyers with verified suppliers and keeps product, delivery, tax, and payment details visible throughout the order process.</p>
        </details>
        <details>
          <summary>How does buying from multiple suppliers work?</summary>
          <p>You can request products from several suppliers in one order. Each supplier independently confirms inventory, shipping or pickup, taxes, and delivery timing before payment. See the full <Link to={localizedPath('/shipping-policy')}>shipping and pickup policy</Link>.</p>
        </details>
        <details>
          <summary>When do I pay for an order?</summary>
          <p>Payment becomes available after a supplier accepts its part of the order and confirms the final commercial terms. Review Eulua's <Link to={localizedPath('/payment-methods')}>secure payment process</Link>.</p>
        </details>
        <details>
          <summary>Can I pick up an order from a supplier?</summary>
          <p>Yes, when pickup is available. The supplier city and country are shown before payment, and exact pickup details are released after payment is confirmed.</p>
        </details>
        <details>
          <summary>How can my business sell on Eulua?</summary>
          <p>Create an account, submit the supplier application, and provide the requested business and identity details for verification. <Link to={localizedPath('/sell/register')}>Apply to become a supplier</Link>.</p>
        </details>
      </div>
    </div>
  </section>
  );
};

export default FaqSection;
